import { useTranslate } from "@similarweb/i18n-provider";
import { Tooltip } from "@similarweb/ui-components";
import { Flex } from "@similarweb/ui-components/foundations";

import { VisibilityBadge } from "app/pages/sales-intelligence/common-components/VisibilityBadge/VisibilityBadge";
import { ScoringConfigType } from "app/pages/sales-intelligence/domain/leads/types/scoring-config";

type ScoringScopeBadgeProps = {
    scope?: ScoringConfigType;
    dataAutomationSuffix?: string;
    /** The tooltip states that the rule reaches the whole account, which only holds without teams. */
    showSharedTooltip?: boolean;
};

const SHARED_SCOPE_TOOLTIP_KEY = "si.pages.score_settings.card.scope.shared.tooltip";

export const ScoringScopeBadge = ({
    scope,
    dataAutomationSuffix,
    showSharedTooltip = true,
}: ScoringScopeBadgeProps) => {
    const { translate } = useTranslate();

    if (!scope) {
        return null;
    }

    const isShared = scope === ScoringConfigType.Account;

    const badge = (
        <VisibilityBadge
            isShared={isShared}
            dataAutomationSuffix={dataAutomationSuffix}
        />
    );

    if (!isShared || !showSharedTooltip) {
        return badge;
    }

    return (
        <Tooltip
            placement="top"
            content={translate(SHARED_SCOPE_TOOLTIP_KEY)}
        >
            <Flex
                width="fit-content"
                data-automation={
                    dataAutomationSuffix
                        ? `scoring-rule-card.scope-badge-${dataAutomationSuffix}`
                        : "scoring-rule-card.scope-badge"
                }
            >
                {badge}
            </Flex>
        </Tooltip>
    );
};
